import { platform } from '../platform.ts';

const dialogs: Array<() => void> = [];

/** Native Back dismisses only the top dialog, without navigating underneath it. */
export function registerBackDialog(close: () => void): () => void {
  dialogs.push(close);
  return () => {
    const index = dialogs.indexOf(close);
    if (index >= 0) dialogs.splice(index, 1);
  };
}

export function dismissTopDialog(): boolean {
  const close = dialogs.at(-1);
  if (!close) return false;
  close();
  return true;
}

export async function installNativeBackNavigation(): Promise<void> {
  if (platform() !== 'android') return;
  const { App } = await import('@capacitor/app');
  await App.addListener('backButton', ({ canGoBack }) => {
    if (dismissTopDialog()) return;
    if (canGoBack) window.history.back();
    else void App.minimizeApp();
  });
}
